export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-slate-900">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2f9a94e5d955bc57d49075801c360c88.jpg"
          alt="金門新港口航拍"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32">
        <div className="max-w-4xl">
          {/* Label */}
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-slate-800/80 backdrop-blur-sm rounded-md border border-slate-700 mb-8">
            <i className="ri-building-line text-slate-300 text-sm"></i>
            <span className="text-slate-300 text-sm font-medium tracking-wide">市場評估報告</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight mb-6">
            金門｜交通節點升級後的
            <span className="block mt-2 text-slate-300">餐飲市場評估</span>
          </h1>

          {/* Subheadline */}
          <div className="flex flex-wrap items-center gap-3 mb-8">
            <span className="px-4 py-2 bg-slate-800/60 backdrop-blur-sm text-slate-200 text-base font-medium rounded-md border border-slate-700 whitespace-nowrap">
              新港口啟用
            </span>
            <span className="text-slate-500">×</span>
            <span className="px-4 py-2 bg-slate-800/60 backdrop-blur-sm text-slate-200 text-base font-medium rounded-md border border-slate-700 whitespace-nowrap">
              人流結構改變
            </span>
            <span className="text-slate-500">×</span>
            <span className="px-4 py-2 bg-slate-800/60 backdrop-blur-sm text-slate-200 text-base font-medium rounded-md border border-slate-700 whitespace-nowrap">
              品牌進場時點
            </span>
          </div>

          {/* Body Text */}
          <p className="text-lg text-slate-300 leading-relaxed mb-12 max-w-3xl">
            金門正處於重要轉型階段。隨著港口與航空運能升級，觀光與跨區人流逐步由短期事件型，轉為可預期、可重複的常態型流量。本展示站以實際基礎建設與人流入口為核心，提供連鎖餐飲品牌進行市場評估與展店判斷之依據。
          </p>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-slate-700/50">
            <div>
              <div className="text-3xl font-black text-white mb-2">399萬</div>
              <div className="text-sm text-slate-400">2025交通旅運量</div>
            </div>
            <div>
              <div className="text-3xl font-black text-white mb-2 whitespace-nowrap">520萬–680萬</div>
              <div className="text-sm text-slate-400">2026推估（Upside）</div>
            </div>
            <div>
              <div className="text-3xl font-black text-white mb-2">+8%–15%</div>
              <div className="text-sm text-slate-400">翔安機場增量</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center space-y-2 animate-bounce">
        <span className="text-slate-400 text-xs tracking-wider">向下滾動</span>
        <i className="ri-arrow-down-line text-slate-400 text-xl"></i>
      </div>
    </section>
  );
}
